<template>
  <section class="content">
    <div class="row center-block">
      <div class="box">
        <div class="box-header">
          <h3 class="box-title">Add Cars</h3>
        </div>
        <div class="box-body">
          <form @submit.prevent>
            <div class="modal-body test col-md-12">
              <div class="form-group col-md-6">
                <label for="exampleInputEmail1">Variant Type <b>*</b></label>
                <select class="form-control" v-model="variantType" required>
                  <option
                    v-for="(type, i) in variantTypes"
                    :key="i"
                    :value="type"
                  >
                    <span class="camel-case">
                      {{ type }}
                    </span>
                  </option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label for="exampleInputEmail1">Car <b>*</b></label>
                <select class="form-control" v-model="Car" required>
                  <option v-for="car in Cars" :key="car._id" :value="car">
                    {{ car.name }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label for="exampleInputEmail1" class="camel-case"
                  >{{ variantType }} Name <b>*</b></label
                >
                <input
                  type="text"
                  v-model="Color"
                  required
                  class="form-control"
                  placeholder="Enter Name"
                />
              </div>
              <div class="form-group col-md-6">
                <label for="exampleInputEmail1">Price <b>*</b></label>
                <input
                  type="number"
                  v-model="Price"
                  required
                  class="form-control"
                  placeholder="Enter MSRP"
                />
              </div>
              <div class="form-group col-md-6" v-if="variantType === 'color'">
                <label for="exampleInputEmail1">Image <b>*</b></label>
                <input
                  type="file"
                  id="file"
                  ref="file"
                  class="form-control"
                  accept="image/*"
                  required
                  v-on:change="handleFileUpload()"
                />
              </div>
            </div>

            <div class="modal-footer test">
              <button
                type="submit"
                class="btn btn-primary"
                v-on:click="AddCar()"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="modal" id="exampleModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Modal title</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent>
              <div class="modal-body test col-md-12">
                <div class="form-group col-md-6">
                  <label for="exampleInputEmail1">Name <b>*</b></label>
                  <input
                    type="text"
                    v-model="modalCarName"
                    required
                    class="form-control"
                    placeholder="Enter Name"
                  />
                </div>
                <div class="form-group col-md-6">
                  <label for="exampleInputEmail1">MSRP <b>*</b></label>
                  <input
                    type="number"
                    v-model="modalCarPrice"
                    required
                    class="form-control"
                    placeholder="Enter MSRP"
                  />
                </div>
              </div>

              <div class="modal-footer test">
                <button
                  type="submit"
                  class="btn btn-primary"
                  v-on:click="EditCar()"
                >
                  Edit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="row center-block">
      <div class="box">
        <div class="col-md-3">
          <label for="exampleInputEmail1">Filter by Type <b>*</b></label>
          <select class="form-control" v-model="filterType" required>
            <option v-for="(type, i) in variantTypes" :key="i" :value="type">
              <span class="camel-case">
                {{ type }}
              </span>
            </option>
          </select>
        </div>
        <div class="box-body">
          <div
            class="dataTables_wrapper form-inline dt-bootstrap"
            id="example1_wrapper"
          >
            <div class="row">
              <div class="col-sm-6">
                <div id="example1_length" class="dataTables_length"></div>
              </div>
            </div>
            <div class="row box-body">
              <div class="col-sm-12 table-responsive" id="Feedbacks">
                <!-- {{ variants }} -->
                <table
                  aria-describedby="example1_info"
                  role="grid"
                  id="carstable"
                  style="width: 100%"
                  class="
                    display
                    table table-bordered table-striped
                    dataTable
                    wrap
                  "
                >
                  <thead>
                    <tr role="row">
                      <th>No</th>
                      <th>Name</th>
                      <th class="camel-case">{{ filterType }}</th>
                      <th v-if="filterType === 'color'">Image</th>
                      <th>Price</th>
                      <!-- <th>Data</th> -->
                      <!-- <th></th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      class="even"
                      role="row"
                      v-for="(S, index) in variants"
                      :key="index"
                    >
                      <td class="sorting_1">{{ index + 1 }}</td>
                      <td class="sorting_1">{{ S.car.name }}</td>
                      <td class="sorting_1">{{ S.typeSubCategory }}</td>
                      <td class="sorting_1" v-if="filterType === 'color'">
                        <img
                          :src="S.url"
                          :alt="S.typeSubCategory"
                          width="150"
                          @click="changeImage(S, 'logo' + index)"
                        />

                        <input
                          type="file"
                          :ref="'logo' + index"
                          :id="'logo' + index"
                          class="form-control"
                          accept="image/*"
                          style="display: none"
                          v-on:change="changeLogo(S, 'logo' + index)"
                        />
                      </td>
                      <td class="sorting_1">{{ S.price }}</td>
                      <!-- <td class="sorting_1 td-max-width">{{S.Data.ciphertext.toString()}}</td> -->
                      <!-- <td>
                        <button
                          type="submit"
                          class="btn btn-outline-delete"
                          data-toggle="modal"
                          data-target="#exampleModal"
                          v-on:click="openModal(S)"
                        >
                          Edit
                        </button>
                        <button
                          type="submit"
                          class="btn btn-outline-delete"
                          v-on:click="DeleteFile(S)"
                        >
                          Delete
                        </button>
                      </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import $ from "jquery";
import moment from "moment";
import axios from "axios";
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";

import { globalStore } from "../../main.js";

// Require needed datatables modules
require("datatables.net");
require("datatables.net-bs");

var aesjs = require("aes-js");
var eccrypto = require("eccrypto");

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      Name: "",
      Color: "",
      Price: "",
      Car: {},
      Cars: [],
      variants: [],
      maker: {},
      token: JSON.parse(localStorage.getItem("token")),
      hasType: false,
      type: "",
      msrp: "",
      Types: [],
      modalCarName: "",
      modalCarPrice: "",
      modalCarId: "",
      variantType: "color",
      filterType: "color",
      variantTypes: ["color", "options"],
      dataTable: undefined,
    };
  },
  mounted() {
    // console.log("token", this.token);
    this.getAllCars();
    this.getAllCarVariants();
  },
  watch: {
    maker(val) {
      console.log("val", val);
      this.hasType = val.hasType;
      if (this.hasType) {
        this.getTypesForMaker(val._id);
      }
      console.log("hasType", this.hasType);
    },
    filterType(val) {
      this.getAllCarVariants(val);
    },
  },
  methods: {
    openModal(car) {
      this.modalCarId = car._id;
      this.modalCarName = car.name;
      this.modalCarPrice = car.price;
    },
    EditCar() {
      let data = {
        carId: this.modalCarId,
        name: this.modalCarName,
        price: this.modalCarPrice,
      };
      console.log("data", data);
      if (
        this.modalCarPrice === "" ||
        this.modalCarId === "" ||
        this.modalCarName === ""
      ) {
        Swal.fire("Oops...", "Enter all values and try again", "error");
        return;
      }
      axios
        .put(globalStore.url + `product/update-car`, data, this.token)
        .then((res) => {
          console.log("saved success", res);
          Swal.fire({
            icon: "success",
            title: "Your Car has been saved",
            showConfirmButton: false,
            timer: 1500,
          });
          setTimeout(() => {
            location.reload();
          }, 1000);
        })
        .catch((e) => {
          console.log("error saving file", e);
          Swal.fire("Oops...", "Something went wrong!", "error");
        });
    },
    async handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.fileType = this.file.type;
      this.fileName = this.file.name;
      console.log("this.file", this.file);
      console.log("this.file", this.fileType);
      console.log("this.file", this.fileName);
      // this.Text = await this.toBase64(this.file);
      // console.log(await this.toBase64(this.file));
    },
    async AddCar() {
      let formData = new FormData();
      formData.append("car", this.Car._id);
      formData.append("typeCategory", this.variantType);
      formData.append("typeSubCategory", this.Color);
      formData.append("price", this.Price);
      if (this.variantType === "color") {
        formData.append("photo", this.$refs.file.files[0]);
      }
      console.log("formData", formData);
      let headers = {
        headers: {
          "Content-Type": "multipart/form-data",
          authtoken: this.token.headers.authtoken,
        },
      };
      console.log(headers);
      // return;
      axios
        .post(globalStore.url + `product/createCarVariant`, formData, headers)
        .then((res) => {
          console.log("saved success", res);
          Swal.fire({
            icon: "success",
            title: "Your Car Variant has been saved",
            showConfirmButton: false,
            timer: 1500,
          });
          location.reload();
        })
        .catch((e) => {
          console.log("error saving file", e);
          Swal.fire("Oops...", "Something went wrong!", "error");
        });
    },
    getAllCarVariants(variantType) {
      let query = "";
      if (variantType && variantType.trim()) {
        query = `product/getAllCarVariants?variantType=${variantType}`;
      }
      query = `product/getAllCarVariants?variantType=${this.filterType}`;
      axios
        .get(globalStore.url + `${query}`, this.token)
        .then((res) => {
          console.log("all variants", res.data.data);
          this.variants = res.data.data;
          setTimeout(() => {
            // if (this.dataTable) {
              // this.dataTable.clear().draw();
            // }
            this.DisplayTable();
          }, 150);
        })
        .catch((e) => {
          console.log("error getting all files", e);
        });
    },
    async getTypesForMaker(makerId) {
      await axios
        .get(
          globalStore.url + `product/getCarTypeByCompany/` + makerId,
          this.token
        )
        .then(async (res) => {
          console.log("all Makers", res.data.data);
          this.Types = await res.data.data;
        })
        .catch((e) => {
          console.log("error getting all files", e);
        });
    },
    getAllCars() {
      axios
        .get(globalStore.url + `product/getAllCars`, this.token)
        .then((res) => {
          console.log("all cars", res.data.data);
          setTimeout(() => {
            this.DisplayTable();
          }, 150);
          this.Cars = res.data.data;
        })
        .catch((e) => {
          console.log("error getting all files", e);
        });
    },
    DeleteFile(car) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          let data = {
            carId: car._id,
          };
          console.log(data);
          axios
            .put(globalStore.url + "product/delete-car", data, this.token)
            .then((res) => {
              Swal.fire({
                icon: "success",
                title: "car is deleted",
                showConfirmButton: false,
                timer: 1500,
              });
              this.getAllCars();
            })
            .catch((e) => {
              console.log("error deleteing", e);
              Swal.fire("Oops...", "Something went wrong!", "error");
            });
        }
      });
    },
    async changeLogo(car, id) {
      let carId = car._id;
      let file = this.$refs[id][0].files[0];
      if (!carId || !file) {
        return;
      }
      console.log(carId);
      console.log(this.$refs);
      console.log(this.$refs[id][0].files[0]);
      let formData = new FormData();
      formData.append("carVariantId", carId);
      formData.append("photo", file);
      console.log("formData", formData);
      let headers = {
        headers: {
          "Content-Type": "multipart/form-data",
          authtoken: this.token.headers.authtoken,
        },
      };
      console.log(headers);
      // return;
      axios
        .put(
          globalStore.url + `product/variant-photo-update`,
          formData,
          headers
        )
        .then((res) => {
          console.log("saved success", res);
          Swal.fire({
            icon: "success",
            title: "Your image has been saved",
            showConfirmButton: false,
            timer: 1500,
          });
          this.getAllCarVariants();
        })
        .catch((e) => {
          console.log("error saving file", e);
          Swal.fire("Oops...", "Something went wrong!", "error");
        });
      return;
    },
    changeImage(maker, id) {
      document.getElementById(id).click();
    },
    DisplayTable() {
      setTimeout(() => {
        this.$nextTick(() => {
          this.dataTable = $("#carstable").DataTable({
            dom: "Blftip",
            orderCellsTop: true,
            fixedHeader: true,
            fixedColumns: true,
            autoWidth: false,
            buttons: [
              {
                extend: "csvHtml5",
                text: "Export To Excel",
                title: "All Feedback",
              },
            ],
          });

          // Setup - add a text input to each footer cell
          $("#example thead tr").clone(true).appendTo("#example thead");
          $("#example thead tr:eq(1) th").each(function (i) {
            var title = $(this).text();
            $(this).html(
              '<input type="text" placeholder="Search ' + title + '" />'
            );

            $("input", this).on("keyup change", function () {
              if (table.column(i).search() !== this.value) {
                table.column(i).search(this.value).draw();
              }
            });
          });
        });
      }, 100);
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
img {
  /* max-width: 30% !important; */
  min-width: 100px;
  /* height: 100px !important; */
}
.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.td-max-width {
  max-width: 200px !important;
  word-wrap: break-word;
  /* white-space: nowrap; 
  width: 50px; 
  overflow: hidden;
  text-overflow: ellipsis; */
}

.lds-ripple div {
  position: absolute;
  border: 4px solid #fff;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}

@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }

  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}

.timeline-footer a.btn {
  margin-right: 10px;
}

tfoot input {
  width: 10%;
  padding: 3px;
  box-sizing: border-box;
}

.test {
  background-color: white;
}
.camel-case {
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// AddVariants.vue?441b0f52